import Swal, { SweetAlertResult } from 'sweetalert2';

interface AlertProps {
  title?: string;
  text: string;
  icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
  confirmButtonText?: string;
  [key: string]: any;
}

export const showAlert = ({
  title = '알림',
  text,
  icon = 'info',
  confirmButtonText = '확인',
  ...props
}: AlertProps) => {
  return Swal.fire({
    title,
    text, 
    icon,
    confirmButtonText,
    customClass: {
      popup: 'custom-popup',
      confirmButton: 'custom-confirm-button',
    },
    ...props
  });
};

export const showError = (message: string) => {
  return showAlert({
    title: '오류',
    text: message,
    icon: 'error'
  });
};

export const showSuccess = (message: string) => {
  return showAlert({
    title: '성공',
    text: message,
    icon: 'success'
  });
};

export const showConfirm = (message: string): Promise<SweetAlertResult<boolean>> => {
  return Swal.fire({
    title: '확인',
    text: message,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: '확인',
    cancelButtonText: '취소'
  });
};